export default {
    notAuthRoute: "landing",
    authRoute: "dashboard",
    locale : {
        key: "ka",
        id: 1,
        value: "ქართული"
    }
}